<template>
    <div class="md-example-child md-example-child-md-activity-indicator md-example-child-md-activity-indicator-1">
        <md-activity-indicator
                type="spinner"
                :size="30"
                :text-size="14"
        >加载中...</md-activity-indicator>
    </div>
</template>

<script>
    import {ActivityIndicator} from 'mand-mobile'

    export default {
        name: 'activity-indicator-demo',
        title: 'Spinner',
        components: {
            [ActivityIndicator.name]: ActivityIndicator,
        },
    }

</script>

<style lang="stylus" scoped>
    .md-example-child-md-activity-indicator-1
        display flex
        flex-direction column
        align-items center
        .md-activity-indicator
            margin-top 30px
            margin-bottom 30px
</style>